import { Injectable } from '@angular/core';
import { ConsentDto } from '../dtos/consent.dto';
import { Consent, ConsentStatus } from '../../domain/models/consent.model';

// Same int/string-enum-to-literal translation style as `clinical-history.mapper.ts`'s
// `TIMELINE_TYPE_MAP` -- a lookup table kept in sync with the backend's `ConsentRequestStatus`
// enum (Pending/Signed/Declined), whose `.ToString()` value is exactly what `ConsentDto.Status`
// carries over the wire (see `ConsentService.Map` in ConsentService.cs).
const STATUS_MAP: Record<ConsentDto['Status'], ConsentStatus> = {
  Signed: 'signed',
  Pending: 'pending',
  Declined: 'declined',
};

@Injectable()
export class ConsentMapper {
  public toConsent(dto: ConsentDto): Consent {
    return {
      id: String(dto.Id),
      documentType: dto.DocumentType,
      version: dto.Version,
      status: STATUS_MAP[dto.Status],
      requestedAtUtc: dto.RequestedAtUtc ?? null,
      acceptedAtUtc: dto.AcceptedAtUtc ?? null,
    };
  }
}
